<template>
  <div class="pa-2">
    <apexchart :height="chartHeight" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { toEur } from '@/mixins/filter';

export default {
  name: 'DashboardChart',
  props: {
    item: {}
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState('sshcf', ['dashboard']),
    chartOptions() {
      const labels = this.dashboard?.result?.map(item => item.name);
      return {
        chart: {
          type: 'line',
          toolbar: {
            tools: {
              download: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false
            }
          }
        },
        legend: {
          show: false
        },
        stroke: {
          curve: 'smooth',
          width: [0, 4]
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [0],
          offsetY: -15,
          background: {
            enabled: false
          }
        },
        labels,
        xaxis: {
          // type: 'datetime'
        },
        yaxis: [
          // Amount of Support
          {
            title: {
              text: 'in MIDR'
            }
          },
          // Hospital
          {
            opposite: true,
            title: {
              // text: ''
            }
          }
        ],
        colors: ['#98ECFF', '#c854b0', '#F2994A'],
        plotOptions: {
          bar: {
            borderRadius: 20,
            horizontal: false,
            columnWidth: '30'
            // endingShape: 'rounded'
          }
        }
      };
    },
    series() {
      return [
        {
          name: 'Amount of Support',
          type: 'column',
          data: this.dashboard?.result?.map(item => +toEur(item.support_amount))
        },
        {
          name: 'Hospital',
          type: 'line',
          data: this.dashboard?.result?.map(item => item.hospital)
        }
        // {
        //   name: 'Average of Support',
        //   type: 'column',
        //   data: this.dashboard?.result?.map(item => item.average_support)
        // }
      ];
    },
    chartHeight() {
      return 250;
    }
  }
};
</script>
